<template>
  <div data-vuetify style="height: 0px !important; width: 0px !important">
    <v-app
      v-if="overlay"
      style="font-size:16px; height: 0vh !important; width: 0vw !important"
    >
      <v-content  class="widg_par" v-show="dataready">
        <v-overlay
          :absolute="absolute"
          :opacity="opacity"
          :value="overlay"
          :z-index="zIndex"
        >

          <v-row
            align="center"
            justify="center"
            style="height:80vh"
            v-if="widgetType == 'Button' && !isMobile && onlyFb"
          >
            <WidgetView style="height:100%" />
          </v-row>
          <v-row
            align="center"
            justify="center"
            v-if="widgetType == 'Button' && isMobile && onlyFb"
          >
            <WidgetViewMobile style="height:100%" />
          </v-row>
          <v-row
            align="center"
            justify="center"
            v-if="widgetType == 'Checkbox' && !isMobile && onlyFb"
          >
            <WidgetViewCheckBox style="height:100%" />
          </v-row>
          <v-row
            align="center"
            justify="center"
            v-if="widgetType == 'Checkbox' && isMobile && onlyFb"
          >
            <WidgetViewCheckBoxMobile style="height:100%" />
          </v-row>

          <v-row align="center" justify="center" v-if="onlySMS && !isMobile">
            <WidgetViewSMS style="height:100%" />
          </v-row>

          <v-row align="center" justify="center" v-if="onlySMS && isMobile">
            <WidgetViewSMSMobile style="height:100%" />
          </v-row>


          <v-row v-if="onlyWa && !onlyFb && !onlySMS && !bothSmsFb && !isMobile">
            <WidgetViewWhatsApp style="height:100%" />
          </v-row>

          <v-row align="center" justify="center" v-if="onlyWa && !onlyFb && !onlySMS && !bothSmsFb && isMobile">
            <WidgetViewWaMobile style="height:100%" />
          </v-row>
<!--          /* must be mobile whatsapp */-->

<!--          <v-row align="center" justify="center" v-if="onlyWa && !isMobile">-->
<!--             <WidgetViewWa style="height: 100%" />-->
<!--          </v-row>-->

<!--          <v-row align="center" justify="center" v-if="onlyWa && isMobile">-->
<!--            <WidgetViewWaMobile style="height: 100%" />-->
<!--          </v-row>-->

          <v-row align="center" justify="center" v-if=" bothSmsFb && !isMobile">
            <WidgetViewTabs style="height:100%" />
          </v-row>

          <v-row align="center" justify="center" v-if=" bothSmsFb && isMobile">
            <WidgetViewTabsMobile style="height:100%" />
          </v-row>
        </v-overlay>
      </v-content>
    </v-app>
  </div>
</template>

//
<script>
//Main app entry
// import WidgetViewWa from "@/components/Widgets/WidgetViewWa.vue"
// import WidgetViewWaMobile from "@/components/Widgets/WidgetViewWaMobile.vue"
import WidgetViewWaMobile from "@/components/Widgets/WidgetViewWaMobile.vue";
import WidgetViewWhatsApp from "@/components/Widgets/WidgetViewWa.vue";
import WidgetView from "@/components/Widgets/WidgetView.vue";
import WidgetViewCheckBox from "@/components/Widgets/WidgetViewCheckBox.vue";
import WidgetViewMobile from "@/components/Widgets/WidgetViewMobile.vue";
import WidgetViewCheckBoxMobile from "@/components/Widgets/WidgetViewCheckBoxMobile.vue";
import WidgetViewSMS from "@/components/Widgets/WidgetViewSMS.vue";
import WidgetViewTabs from "@/components/Widgets/WidgetViewTabs.vue";
import WidgetViewTabsMobile from "@/components/Widgets/WidgetViewTabsMobile.vue";
import WidgetViewSMSMobile from "@/components/Widgets/WidgetViewSMSMobile.vue";

import { mapGetters } from "vuex";

export default {
  name: "App",
  props: ["instance_id", "cart_id"],

  beforeCreate() {
    this.$store.dispatch("updateToken", "1234").then(() => {
      this.instanceId = document.querySelector("widget-view").instance_id;
      this.$store.dispatch("getWidgets", this.instanceId).then(() => {
        this.$store.dispatch("getSettings", this.instanceId).then(() => {
          this.$store.dispatch("incrementFBKey");
        });
      });
    });
  },
  mounted() {
    setTimeout(() => this.dataready = true ,1200)
  },
  components: {
    WidgetView,
    WidgetViewCheckBox,
    WidgetViewMobile,
    WidgetViewCheckBoxMobile,
    WidgetViewSMS,
    WidgetViewTabs,
    WidgetViewTabsMobile,
    WidgetViewSMSMobile,
    WidgetViewWhatsApp,
    // WidgetViewWa,
    WidgetViewWaMobile
  },
  data() {
    return {
      instanceId: "",
      absolute: false,
      opacity: 0.46,
      zIndex: 100000,
      a:[],
      dataready:false,
    };
  },
  computed: {
    ...mapGetters(["getDisplayWidget", "getWidgetsState"]),
    widgetType() {
      return this.getWidgetsState.facebook_widget_type;
    },
    onlyFb() {
      // return false
      if (this.getWidgetsState.enabled_widgets.facebook !== false && this.getWidgetsState.enabled_widgets.sms == false &&
        this.getWidgetsState.enabled_widgets.whatsapp == false) {
        return true;
      } else {
        return false;
      }
    },
    onlySMS() {
      // return false
      if (this.getWidgetsState.enabled_widgets.facebook == false && this.getWidgetsState.enabled_widgets.sms !== false &&
        this.getWidgetsState.enabled_widgets.whatsapp == false) {
        return true;
      } else {
        return false;
      }
    },
    onlyWa(){
      if(this.getWidgetsState.enabled_widgets.whatsapp !== false
        && this.getWidgetsState.enabled_widgets.facebook == false && this.getWidgetsState.enabled_widgets.sms == false
      ){
        return true
      }else {
        return false
      }
    },
    // allTogether(){
    //   if(this.getWidgetsState.enabled_widgets.whatsapp !== false && this.getWidgetsState.enabled_widgets.facebook !== false
    //   && this.getWidgetsState.enabled_widgets.sms !== false){
    //     return true
    //   } else return  false
    // },
    // someWidget(){
    //
    // },
    // onlyWa(){
    //   if(this.getWidgetsState.enabled_widgets.wa == 0){
    //     return true
    //   }else {
    //     return false
    //   }
    // },
    bothSmsFb() {
      if (
        ( this.getWidgetsState.enabled_widgets.facebook !== false &&
        this.getWidgetsState.enabled_widgets.sms !== false && this.getWidgetsState.enabled_widgets.whatsapp == false ) ||
        ( this.getWidgetsState.enabled_widgets.facebook !== false &&
          this.getWidgetsState.enabled_widgets.sms == false && this.getWidgetsState.enabled_widgets.whatsapp !== false ) ||
        ( this.getWidgetsState.enabled_widgets.facebook == false &&
          this.getWidgetsState.enabled_widgets.sms !== false && this.getWidgetsState.enabled_widgets.whatsapp !== false ) ||
        (this.getWidgetsState.enabled_widgets.whatsapp !== false && this.getWidgetsState.enabled_widgets.facebook !== false
          && this.getWidgetsState.enabled_widgets.sms !== false)
      ) {
        return true;
      } else {
        return false;
      }
    },
    getFbKey() {
      return this.$store.getters.getFbKey;
    },
    overlay() {
      return this.getDisplayWidget ? true : false;
    },
    isMobile() {
      // return true
      if (screen.width <= 900) {
        return true;
      } else {
        return false;
      }
    },
  },

};
</script>

<style>

.v-tab{
  cursor: inherit !Important;
}
.v-ripple__container{
  background-color: red !important;
}
.v-tab::before:focus {
  background-color: red !important;
}
.v-tab::before:active {
  background-color: red !important;
}
.ipad_flex{
  align-items: center;
}
[data-vuetify] .theme--light.v-tabs > .v-tabs-bar {
  background-color: #ffffff00 !important;
}
[data-vuetify] .v-tab:before {
  background-color: #f0f8ff00 !important;
}
.v-tab:active {
  background-color: #f0f8ff00 !important;
}

.v-tab ::selection{
  color: #fff0 !important;
}
.v-ripple__container{
  background-color: #f0f8ff00 !important;
}
.material-icons{
  visibility: hidden !important;
}
[data-vuetify] .v-tabs-slider-wrapper{
  visibility: hidden;
}
.header_dims {
  font-size: 100% !important;
  overflow: hidden;
}

.btnfonts_dims {
  font-size: 60% !important;
  overflow: hidden;
}

.page_headers {
  color: #323f4f;
  font-weight: bold !important;
  text-transform: uppercase;
}

@media (min-width: 1400px) {
  .header_dims {
    font-size: 140% !important;
    overflow: hidden;
  }
  .btnfonts_dims {
    font-size: 85% !important;
  }
}

@media (max-width: 325px) {
  [data-vuetify] .v-btn:not(.v-btn--round).v-size--default {
    height: 27px !important;
  }
}

</style>
